// extracted by mini-css-extract-plugin
export var closeButton = "_pi-2";
export var closeButtonIcon = "_pi-3";
export var lightboxContent = "_pi-1";
export var lightboxOverlay = "_pi-0";